import useSWR, { type SWRConfiguration } from 'swr';
import useCurrentUser from '@/lib/hooks/useCurrentUser';
import { fetcher } from '@/utils/services';

const useOrgContext = (orgId: string, swrOptions: SWRConfiguration) => {
  // Passing the org_id param will allow super admins to get additional contexts
  // beyond their primary Instil one. If the user is not a Super Admin, this
  // param will do nothing.
  const { isSuperAdmin } = useCurrentUser();
  return useSWR(
    orgId && isSuperAdmin ? `context?org_id=${orgId}` : `context`,
    fetcher,
    swrOptions,
  );
};

export default useOrgContext;
